import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ParcelAppEntityParcelWrite
} from '../../../../../../../openapi';
import { RoadControlsForm } from '../../../../common/components/road-controls-set/road-controls.form';
import { environment } from '../../../../../../../../environments/environment';

@Injectable()
export class LocalisationForm extends RoadControlsForm {
  constructor() {
    super({
      geometry: new FormControl(null, environment.production ? Validators.required : []),

      parcels: new FormControl([], {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(1), Validators.maxLength(255)]
      })
    });
  }

  public get geometry(): FormControl {
    return this.get('geometry') as FormControl;
  }

  private get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return this.parcels.value;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {

      geometry: this.geometry.value,

      street: this.street.value,
      roadName: this.roadName.value,
      roadNumber: this.roadNumber.value
    };
  }

  public override patchFormValues(app: ApplicationAppEntityApplicationRead): void {
    this.parcels.setValue(app?.parcels || []);
    super.patchFormValues(app);
  }
}
